export interface ServiceProviderTypeDto {
  name: string;
  description: string;
}

export class ServiceProviderTypeLookup {
  public static readonly types: ServiceProviderTypeDto[] = [
    {
      name: 'Nhf',
      description: 'Nfz',
    },
    {
      name: 'Private',
      description: 'Prywatny',
    },
  ];
}
